import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withNamespaces } from 'react-i18next'
import i18next from 'i18next'
import BalanceRequest from './balance/BalanceRequest'
import ListRequestItems from './ListRequestItems'
import RequestForm from './RequestForm'
import * as leaveRequestStatusCode from '../../scripts/LeaveRequestStatusCode'
import * as requestTypeCode from '../../scripts/RequestTypeCode'
import * as pageSourceCode from '../../scripts/PageSourceCode'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import { isIOS } from '../../utils'
import Dialog from '@material-ui/core/Dialog'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        maxWidth: '900px',
        '@media (max-width: 600px)': {
            width: "100%"
        },
        backgroundColor: theme.palette.background.paper,
        padding: '10px',
        justifySelf: 'center',
    },
    divAddButton: {
        position: 'relative',
        zIndex: 1
    },
    divPendingRequests: {
        marginTop: '15px'
    },
    divRecentHistory: {
        marginTop: '15px'
    },
    titlePendingRequests: {
        color: 'var(--color1)',
        display: 'flex',
        width: '100%',
        fontWeight: 'bold',
        marginBottom: '10px'
    },
    titleRecentHistory: {
        color: 'var(--color1)',
        display: 'flex',
        width: '100%',
        fontWeight: 'bold',
        marginBottom: '10px'
    },
    appBarForm: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important',
    },
    titleAppBarForm: {
        marginLeft: theme.spacing(2),
        flex: 1,
    }
}));
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function RequestHome() {
    const classes = useStyles();

    const [isiOS, setIsiOS] = React.useState(isIOS());
    const [open, setOpen] = React.useState(false);
    const [isReload, setIsReload] = React.useState(false);

    const filterPendingRequests = {
        typeRequest: [requestTypeCode.Type_Leave, requestTypeCode.Type_Vacation],
        status: [leaveRequestStatusCode.Status_Opened]
    }
    const filterRecentHistory = {
        typeRequest: [requestTypeCode.Type_Leave, requestTypeCode.Type_Vacation],
        status: [leaveRequestStatusCode.Status_Opened,
        leaveRequestStatusCode.Status_Canceled,
        leaveRequestStatusCode.Status_Cancel_Request,
        leaveRequestStatusCode.Status_Close]
    }

    useEffect(() => {
        resizePage();
    }, []);

    const resizePage = () => {
        const height = window.innerHeight;
        const titleBar = document.querySelector('#appBarTitle').clientHeight;
        const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
        const element = document.querySelector('#divRequestHome');
        const offSet = 30;

        const customHeight = height - header - titleBar - offSet;

        if (element !== null) {
            element.style.height = `${customHeight}px`;
            element.style.overflowX = 'hidden';
        }
    }

    const resizeFormPendingRequests = () => {
        // This code is to resize the section of pending requests
        // For the moment we decided to remove this resize
        // We will not have a section scroll, but the entire page will scroll
        // Please do not delete this code for now

        //const height = window.innerHeight;
        //const titleBar = document.querySelector('#appBarTitle').clientHeight;
        //const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
        //const element = document.querySelector(`[data-type=${pageSourceCode.PageSource_RequestPendingRequests}]`);
        //const customHeight = height - header - titleBar;
        //if (element !== null) {
        //    element.style.height = `${customHeight - (customHeight / 3 * 2) - 130}px`;
        //    element.style.overflowX = 'hidden';
        //}
    }

    const resizeFormRecentHistory = () => {
        // This code is to resize the section of recent history
        // For the moment we decided to remove this resize
        // We will not have a section scroll, but the entire page will scroll
        // Please do not delete this code for now

        //const height = window.innerHeight;
        //const titleBar = document.querySelector('#appBarTitle').clientHeight;
        //const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
        //const element = document.querySelector(`[data-type=${pageSourceCode.PageSource_RequestRecentHistory}]`);
        //const customHeight = height - header - titleBar;
        //if (element !== null) {
        //    element.style.height = `${customHeight - (customHeight / 3 * 2)}px`;
        //    element.style.overflowX = 'hidden';
        //}
    }

    const handleNewRequest = () => {
        setOpen(true);
        setIsReload(false);
    }

    const handleCloseClick = () => {
        setOpen(false);
        setIsReload(true);
    };

    return (
        <>
            <div id="divRequestHome" className={classes.root}>
                <div className={classes.divAddButton}>
                    <Fab color="primary" aria-label="add" className={`addButtonFab ${isiOS && "addButtonFabIOS"}`} onClick={handleNewRequest}>
                        <AddIcon />
                    </Fab>
                </div>
                <div>
                    <BalanceRequest isReload={isReload} />
                </div>
                <div className={classes.divRecentHistory}>
                    <span className={classes.titleRecentHistory}>{i18next.t('request:title.recentHistory')}</span>
                    <ListRequestItems
                        isReload={isReload}
                        filter={filterRecentHistory}
                        pageSource={pageSourceCode.PageSource_RequestHome}
                        type={pageSourceCode.PageSource_RequestRecentHistory}
                        resizeForm={resizeFormRecentHistory}
                    />
                </div>
                <div className={classes.divPendingRequests}>
                    <span className={classes.titlePendingRequests}>{i18next.t('request:title.pendingRequests')}</span>
                    <ListRequestItems
                        isReload={isReload}
                        filter={filterPendingRequests}
                        pageSource={pageSourceCode.PageSource_RequestHome}
                        type={pageSourceCode.PageSource_RequestPendingRequests}
                        resizeForm={resizeFormPendingRequests}
                    />
                </div>
            </div>
            <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div data-id="headerRequestForm">
                    <AppBar className={classes.appBarForm}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBarForm}>
                                {i18next.t('request:title.request')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divRequestForm">
                    <RequestForm />
                </div>
            </Dialog>
        </>
    );
}

export default withNamespaces(['request'], { wait: true })(RequestHome);